const firstAndSecondLevelElements = document.querySelectorAll(
    '.main-nav__link--level-1, .main-nav__shortcut-container-label'
);

function toggleElement(linkElement, ulElement) {
    if (ulElement.style.display !== 'block') {
        linkElement.classList.add('main-nav__item--open');
        linkElement.setAttribute('aria-expanded', true);
        ulElement.style.display = 'block';
    } else {
        linkElement.classList.remove('main-nav__item--open');
        linkElement.setAttribute('aria-expanded', false);
        ulElement.style.display = null;
    }
}

function toggleSubNavigation(event) {
    const linkElement = event.currentTarget;
    // this is a bit naive, but the CSS also relies on the
    // imitate next sibling being the sub navigation for the
    // element
    const ulElement = linkElement.nextSibling;

    if (ulElement) {
        event.preventDefault();
        toggleElement(linkElement, ulElement);
    }
}

export function initMobileNavigation() {
    const onMobile = window.matchMedia('(max-width: 1200px)').matches;

    if (onMobile) {
        // create
        openActiveElement();
        firstAndSecondLevelElements.forEach((element) => {
            element.addEventListener('click', toggleSubNavigation);
            element.setAttribute('aria-expanded', false);
        });
    } else {
        // destroy
        firstAndSecondLevelElements.forEach((element) => {
            element.removeEventListener('click', toggleSubNavigation);
            element.removeAttribute('aria-expanded');

            const ulElement = element.nextSibling;
            if (ulElement) {
                ulElement.style.display = null;
            }
        });
    }
}

// make sure menu is unfolded for active element
function openActiveElement() {
    const activeElement = document.querySelector('.main-nav__link--active');

    if (activeElement) {
        openElements(activeElement);
    }

    function openElements(element) {
        const closestNavigationContainer = element.closest('.main-nav__item--level-1, .main-nav__shortcut-container');

        if (closestNavigationContainer) {
            const navigationLink = closestNavigationContainer.querySelector(
                '.main-nav__link--level-1, .main-nav__shortcut-container-label'
            );
            const ulElement = navigationLink.nextSibling;

            if (ulElement) {
                toggleElement(navigationLink, ulElement);
                openElements(closestNavigationContainer.parentElement);
            }
        }
    }
}

let delayed;
window.addEventListener('resize', () => {
    if (delayed) {
        clearTimeout(delayed);
    }
    delayed = setTimeout(() => {
        initMobileNavigation();
    }, 500);
});
